import { useEffect, useState } from 'react'
import { Container, Tab, Tabs } from "react-bootstrap";

import {
  FaqBanner,
  FaqTitle,
  FaqText,
  MainTabSection,
  FaqTabSection,
} from './FaqStyle';

import { MESSAGE } from '../../utils/message';
import FaqSupport from './faqSupport';
import FaqSolution from './faqSolution';
import { useLocation } from 'react-router-dom';

const Faq = () => {
  const [tabKey, setTabKey]= useState<string>('support_home');
  const {state} =useLocation();

  useEffect(() => {
    if(state?.activateTab) {
      setTabKey(state.activateTab)
    }else {
      setTabKey('support_home')
    }
  },[state])
  return ( 
    <>
      <FaqBanner>
        <Container className="cont-w">
            <FaqTitle>{MESSAGE.faqHelp}</FaqTitle>
            <FaqText className="heading-tag-line">{MESSAGE.helpTagline}</FaqText>
        </Container>
      </FaqBanner>

        <MainTabSection className="main-tab-bg">
            <Container className="cont-w">
              <FaqTabSection>
              <Tabs defaultActiveKey="support_home" fill activeKey={tabKey} onSelect={(eventKey:any) => setTabKey(eventKey)}>
                
                <Tab eventKey="support_home" title="Support Home">
                  <FaqSupport setTabKey={setTabKey}/>
                </Tab> 

                <Tab eventKey="solution" title="Solution">
                  <FaqSolution />
                </Tab>

              </Tabs>
              </FaqTabSection>
            </Container>
        </MainTabSection>
    </>
  )
}

export default Faq 
